import { createSelector } from 'reselect'

export const getTrailerCurrentPositions = state => state.trailerCurrentPositions.getIn(['all', 'objects'])

export const createGetTrailerCurrentPositionByIDSelector = id =>
    createSelector([getTrailerCurrentPositions], trailerCurrentPositions => trailerCurrentPositions.get(String(id)))

export const getTrailerCurrentPositionsFetching = state => state.trailerCurrentPositions.getIn(['all', 'fetching'])
